// @ts-nocheck
import React, { useEffect } from 'react';
// import PerfectScrollbar from 'react-perfect-scrollbar';

import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../components/Shared/Loader/Loader';
import {
  cleanTransactionHistoryList,
  GetTransactionHistoryWithValueById
} from '../../../store/Ame/ameRequestSlice';
import HistoryList from './HistoryList';
import HeaderRequest from './HeaderRequest/HeaderRequest';
import ContentRequest from './ContentRequest/ContentRequest';
import { Card, CardBody } from '../../../components/card/card';
import Loading from '@components/Shared/Loader/Loading';

const OnlyViewRequests = ({ TransactionHistoryId }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (TransactionHistoryId) {
      dispatch(cleanTransactionHistoryList());
      dispatch(GetTransactionHistoryWithValueById(TransactionHistoryId));
    }
  }, [TransactionHistoryId, dispatch]);
  const data = useSelector(state => state.AmeRequest.TransactionHistoryWithValueList);
  const loading = useSelector(state => state.AmeRequest.loading2);

  if (loading) {
    // return <Loader loading={loading} />;
    return <Loading loading={true} children={<></>} />;
  }

  return (
    <Card>
      <CardBody>
        <HeaderRequest data={data} />
        <ContentRequest data={data} />
        <div className='row mt-3'>
          <div className='col-lg-12'>{data.history && <HistoryList data={data || {}} />}</div>
        </div>
      </CardBody>
    </Card>
  );
};

export default OnlyViewRequests;
